import { HomeIcon, SearchIcon, Target, BarChart3, Sparkles, Settings, MoreHorizontal } from '../../icons';

/** Primary destinations shown in the bottom bar (mobile) and the sidebar (desktop). */
export const PRIMARY_NAV = [
  { id: 'properties', label: 'Properties', icon: HomeIcon },
  { id: 'searches', label: 'Searches', icon: SearchIcon },
  { id: 'opportunities', label: 'Opportunities', icon: Target, badgeKey: 'opportunities' },
];

/** Secondary destinations: sidebar on desktop, "More" sheet on mobile. */
export const SECONDARY_NAV = [
  { id: 'sync-history', label: 'Sync History', icon: BarChart3 },
  { id: 'ai-settings', label: 'AI Settings', icon: Sparkles },
  { id: 'admin', label: 'Admin Panel', icon: Settings, adminOnly: true },
];

export const MORE_TAB = { id: 'more', label: 'More', icon: MoreHorizontal };

export const PAGE_TITLES = {
  properties: 'Properties',
  searches: 'Searches',
  opportunities: 'Opportunities',
  'sync-history': 'Sync History',
  'ai-settings': 'AI Settings',
  admin: 'Admin Panel',
};

export const getNavItems = (isAdmin) =>
  [...PRIMARY_NAV, ...SECONDARY_NAV].filter((item) => !item.adminOnly || isAdmin);
